import Link from 'next/link';

import BiodermaLogo from '@/fo/icons/base/logos/bioderma.svg';
import EsthedermLogo from '@/fo/icons/base/logos/esthederm.svg';
import EtatPurLogo from '@/fo/icons/base/logos/etat-pur.svg';
import NaosLogo from '@/fo/icons/base/logos/naos.svg';

import { styles } from './BrandsSection.styles';

export function BrandsSection() {
  const slots = styles();
  return (
    <div className={slots.base()}>
      <div className={slots.container()}>
        <Link href="/">
          <NaosLogo className={slots.naos()} />
        </Link>

        <div className={slots.divider()} />
        <div className={slots.brands()}>
          <Link
            href="/bioderma"
            className={slots.logo()}
          >
            <BiodermaLogo className={slots.bioderma()} />
          </Link>
          <Link
            href="/esthederm"
            className={slots.logo()}
          >
            <EsthedermLogo className={slots.esthederm()} />
          </Link>
          <Link
            href="/etat_pur"
            className={slots.logo()}
          >
            <EtatPurLogo className={slots.etatPur()} />
          </Link>
        </div>
      </div>
    </div>
  );
}
